<template>
  <div class="content-wrap">
    <header class="content-header cf">
      <h3>{{ $t('areas.zones') }}</h3>
      <div class="header-meta">
        <Link
          v-if="$route.params.area_uuid"
          :to="`/company/sites/${this.$route.params.site_uuid}/areas/${this.$route.params.area_uuid}/zones/new`"
          class="button button-green button-small button-round"
          >{{ $t('areas.addZone') }}</Link
        >
      </div>
    </header>
    <div class="content-body">
      <div v-if="zonesInArea.length === 0" class="alert alert-danger">{{ $t('areas.noZones') }}</div>
      <Table v-else>
        <template #header>
          <th>{{ $t('meta.name') }}</th>
          <th>{{ $t('meta.area') }}</th>
          <th>
            <span class="visually-hidden">{{ $t('meta.actions') }}</span>
          </th>
        </template>
        <template #body>
          <tr v-for="zone in zonesInArea" :key="zone.uuid">
            <td>
              {{ zone.name }}
            </td>
            <td>
              {{ zone.area.name }}
            </td>
            <td class="table__actions">
              <Link
                :to="`/company/sites/${area.site.uuid}/areas/${zone.area.uuid}/zones/${zone.uuid}`"
                class="table__action-button"
                ><span class="material-icons">edit</span></Link
              >
              <button @click="deleteZone(zone)" class="table__action-button">
                <span class="material-icons">delete</span>
              </button>
            </td>
          </tr>
        </template>
      </Table>
      <div class="pagination">
        <pagination
          :records="pagination.totalObjects"
          v-model="pagination.page"
          :per-page="pagination.perPage"
          @paginate="getZonesInArea"
          :options="{ chunk: 5, texts: { count: $t('pagination.text') }, edgeNavigation: true }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'

import Table from '@/components/Table/index.vue'

import zonesApi from '@/api/zones'

export default {
  name: 'ZonesIndex',
  inject: ['showPopup'],
  components: {
    Table,
    Pagination,
  },
  props: {
    area: { type: Object, required: true },
  },
  data() {
    return {
      loading: true,
      pagination: {
        page: 1,
        totalObjects: 0,
        perPage: 0,
      },
      zonesInArea: [],
    }
  },
  methods: {
    async getZonesInArea(page = 1) {
      const currentPage = page || this.pagination.page
      this.loading = true
      const params = {
        page,
      }
      const result = await zonesApi.getInArea(this.area.uuid, params)
      if (!result) {
        this.loading = false
        return
      }
      this.zonesInArea = result.zones
      this.pagination.page = currentPage
      this.pagination.totalObjects = result.pagination?.total_objects
      this.pagination.perPage = result.pagination?.per_page
      this.loading = false
    },
    async deleteZone(zone) {
      if (await this.showPopup({ content: this.$t('sites.deleteZoneConfirmation'), type: 'confirm' })) {
        await zonesApi.delete(zone.area.uuid, zone.uuid)
        await this.getZonesInArea(1)
      }
    },
  },
  async mounted() {
    await this.getZonesInArea()
  },
}
</script>
